import { calculateGrandTotal, initListener } from "./_listener";
import { initSelect2Setup, loaderCircle } from "./_setup";

calculateGrandTotal();
initSelect2Setup();
initListener();

$(".expo-list, #wrapperExpoList").html(loaderCircle);

$(".maskPhoneNumber").mask("000000000000", {
  reverse: true,
  translation: {
    0: {
      pattern: /\d/,
    },
    9: {
      pattern: /\d/,
      optional: true,
    },
    Z: {
      pattern: /[\-\+]/,
      optional: true,
    },
  },
});
